import { ValidationRules } from "aurelia-validation";
import { IDisplayDiagnosis, IPalHealthHistoryDiagnosis } from "../../resources-vue/vue-interfaces/i-diagnosis";
import { IHospitalization } from "../../resources-vue/vue-interfaces/i-health";

export class Hospitalization implements IHospitalization {
    public Id?: string;
    public PatientId: string = "";
    public AdmissionDate: string = "";
    public DischargeDate: string = "";
    public DischargedTo: string = "";
    public Comments: string = "";
    public IsEdEncounter: boolean = false;
    public HospitalizationHistoryDiagnoses: IPalHealthHistoryDiagnosis[] = [];
    public FacilitySourceId: string = "";
    public FacilitySourceName: string = "";
    public FacilityContactName: string = "";
    public CommunityLiaisonId: string = "";
    public CommunityLiaisonFirstName: string = "";
    public CommunityLiaisonLastName: string = "";
    public HospitalUnit: string = "";
    public IsPlanned: boolean = false;
    public IsPreventable: boolean = false;
    public IsStatusUpdateData?: boolean = false;

    public constructor(data?: IHospitalization) {
        if (!!data) {
            Object.assign(this, data);
        }
    }
}
